export default __webpack_public_path__ + "static/diagonalLines-47e8f00be98de160f21714b49a54e471.svg";